var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader contents-loader text-center"},[_c('div',{staticClass:"loader-circle"}),_vm._v(" "),_c('div',{staticClass:"loader-text mt-3"},[(_vm.text)?[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]:[_vm._v("\n      Loading...\n    ")]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b550a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Partials/Loader/Contents.vue
// module id = 703
// module chunks = 0